import { Button, styled } from '@mui/material'

export const OurButton = styled(Button)`
  color: ${(props) => props.theme.palette.primary.dark};
`
